import handleSessionTimer from './sessionTimerHandler';
import handleFooterStatus from './footerStatusHandler';
import handleGotoPage from './gotoPageHandler';
import { executeNewrelicTracerForContent } from './newrelicTracer';

export function PlayerEventHandler(event, callback, args) {
    if (!event) {
        return;
    }

    // when there is an activity callback from UP, we need handle the session timer accordingly
    handleSessionTimer(event, args);

    handleFooterStatus(event, callback);

    handleGotoPage(event, args);

    executeNewrelicTracerForContent(event);
}

